var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 d-flex justify-content-end mb-3" },
      [
        _c(
          "action-button",
          {
            attrs: { i: "fal fa-print", variant: "outline-success" },
            on: {
              click: function($event) {
                return _vm.$emit("print")
              }
            }
          },
          [_vm._v(" Imprimir ")]
        )
      ],
      1
    ),
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "bg-grayish-green rounded text-center p-2" }, [
        _vm._m(0),
        _c("p", { staticClass: "main-text px-1" }, [
          _vm._v(
            " Total de sesiones de terapias elegibles para ofrecer durante el año escolar "
          )
        ]),
        _c("div", { staticClass: "bg-white rounded px-2" }, [
          _c("p", { staticClass: "quantity-text py-4" }, [
            _vm._v(" " + _vm._s(_vm.data.totalEligibleSessions) + " ")
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "bg-grayish-green rounded text-center p-2" }, [
        _vm._m(1),
        _c("p", { staticClass: "main-text px-4 text-wrap" }, [
          _vm._v(" Visitas Regulares Registradas ")
        ]),
        _c("div", { staticClass: "bg-white rounded px-2" }, [
          _c("p", { staticClass: "quantity-text py-4" }, [
            _vm._v(" " + _vm._s(_vm.data.registeredRegularVisits) + " ")
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "bg-grayish-green rounded text-center p-2" }, [
        _vm._m(2),
        _c("p", { staticClass: "main-text px-4 text-wrap" }, [
          _vm._v(" Total Ausencias NO Válidas para Reposición ")
        ]),
        _c("div", { staticClass: "bg-white rounded px-2" }, [
          _c("p", { staticClass: "quantity-text py-4" }, [
            _vm._v(
              " " + _vm._s(_vm.data.totalAbsencesInvalidForReplacement) + " "
            )
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "bg-grayish-green rounded text-center p-2" }, [
        _vm._m(3),
        _c("p", { staticClass: "main-text px-4 text-wrap" }, [
          _vm._v(" Visitas Reposición y/o Ofrecimiento Año Actual ")
        ]),
        _c("div", { staticClass: "bg-white rounded px-2" }, [
          _c("p", { staticClass: "quantity-text py-4" }, [
            _vm._v(
              " " + _vm._s(_vm.data.visitsReplacementOfferCurrentYear) + " "
            )
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "bg-grayish-green rounded text-center p-2" }, [
        _vm._m(4),
        _c("p", { staticClass: "main-text px-3 text-wrap" }, [
          _vm._v(" Balance actual de servicios por ofrecer ")
        ]),
        _c("div", { staticClass: "bg-white rounded px-2" }, [
          _c("p", { staticClass: "quantity-text py-4 text-success" }, [
            _vm._v(" " + _vm._s(_vm.data.currentBalanceServicesOffered) + " ")
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-4 py-3" }, [
      _c("i", { staticClass: "fas-img fa-user-edit-orange" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-4 py-3" }, [
      _c("i", { staticClass: "fas-img fa-calendar-check-bluish-green" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-4 py-3" }, [
      _c("i", { staticClass: "fas-img fa-calendar-minus-circle-red" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-4 py-3" }, [
      _c("i", { staticClass: "fas-img fa-calendar-user-circle-yellow" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-4 py-3" }, [
      _c("i", { staticClass: "fas-img fa-file-plus-green" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }